//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Stack,
} from "@chakra-ui/react";
import { Field } from "formik";
import { observer } from "mobx-react-lite";
import { ILocationFieldStore } from "../../../../stores";
import React, { useEffect } from "react";
import Select from "../../../../components/form-elements/Select";
const defaultPlaceholder = {
  country: { label: "Country", placeholder: "Select country" },
  state: { label: "State", placeholder: "Select state" },
  region: { label: "Region", placeholder: "Select region" },
};
const LocationSelector: React.FC<{
  viewModel: ILocationFieldStore;
  initialValues?: any;
  [key: string]: any;
}> = observer(
  ({
    value,
    placeholder = defaultPlaceholder,
    onChange,
    spacing = "24px",
    flexDirection = "column",
    locationFetchingProps,
    initialValues = {},
    showCountry = false,
    viewModel,
    commonProps,
    ...rest
  }) => {
    // const {
    //   value,
    //   handleChange,
    //   countryOptions,
    //   stateOptions,
    //   regionOptions,
    //   formatOptions
    // } = useLocation(locationFetchingProps);

    let country = viewModel.country || initialValues?.country;

    useEffect(() => {
      onChange && onChange();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewModel.state, viewModel.region, viewModel.country]);
    // console.log({ country });
    return (
      <Stack key={country} spacing={spacing}>
        {country !== "Nigeria" && (
          <Field name="country">
            {({ field, form }) => {
              return (
                <FormControl isInvalid={commonProps(field, form).isInvalid}>
                  <FormLabel htmlFor="country">
                    {viewModel.placeholder.country.label}
                  </FormLabel>
                  <Select
                    id="country"
                    placeholder={viewModel.placeholder.country.placeholder}
                    isSearchable
                    value={viewModel.country}
                    onChange={(selectedOpt) => {
                      viewModel.handleChange("country", selectedOpt.value);
                    }}
                    options={viewModel.formatOptions(viewModel.countryOptions)}
                    {...rest}
                  />
                  <FormErrorMessage>
                    {commonProps(field, form).errorMessage}
                  </FormErrorMessage>
                </FormControl>
              );
            }}
          </Field>
        )}

        <Flex direction={["column", "row"]}>
          <Field name="state">
            {({ field, form }) => {
              return (
                <FormControl
                  flex={1}
                  isInvalid={commonProps(field, form).isInvalid}
                >
                  <FormLabel htmlFor="state">
                    {viewModel.placeholder.state.label}
                  </FormLabel>
                  <Select
                    id="state"
                    placeholder={viewModel.placeholder.state.placeholder}
                    isSearchable
                    value={viewModel.state}
                    onChange={(selectedOpt) =>
                      viewModel.handleChange("state", selectedOpt.value)
                    }
                    options={viewModel.formatOptions(
                      viewModel.stateOptions(viewModel.country)
                    )}
                    {...rest}
                  />
                  <FormErrorMessage>
                    {commonProps(field, form).errorMessage}
                  </FormErrorMessage>
                </FormControl>
              );
            }}
          </Field>

          {country === "Nigeria" && (
            <>
              <Box boxSize={spacing} />
              <Field name="region">
                {({ field, form }) => {
                  return (
                    <FormControl
                      flex={1}
                      isInvalid={commonProps(field, form).isInvalid}
                    >
                      <FormLabel htmlFor="region">
                        {viewModel.state
                          ? `Where in ${viewModel.state}?`
                          : viewModel.placeholder.region.label}
                      </FormLabel>
                      <Select
                        id="region"
                        placeholder={viewModel.placeholder.region.placeholder}
                        isSearchable
                        value={viewModel.region}
                        onChange={(selectedOpt) => {
                          viewModel.handleChange("region", selectedOpt.value);
                        }}
                        options={viewModel.formatOptions(
                          viewModel.regionOptions(viewModel.state)
                        )}
                        {...rest}
                      />
                      <FormErrorMessage>
                        {commonProps(field, form).errorMessage}
                      </FormErrorMessage>
                    </FormControl>
                  );
                }}
              </Field>
            </>
          )}
        </Flex>

        {/* )} */}
      </Stack>
    );
  }
);

export default LocationSelector;
